import { render } from "./RotateAnimation.vue?vue&type=template&id=71dc39a4&scoped=true&ts=true"
import script from "./RotateAnimation.vue?vue&type=script&lang=ts"
export * from "./RotateAnimation.vue?vue&type=script&lang=ts"

import "./RotateAnimation.vue?vue&type=style&index=0&id=71dc39a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dc39a4"]])

export default __exports__